import React from 'react';
import {Checkbox, FormField} from "semantic-ui-react";
import Info from "../../../components/Info";
import NumberInput from "../../../controls/numberInput";

const TotalVolumeAndWeight = ({changeParam, form, errors, isOff, onCalcByPlaces}) => {
    return <div className={`d-flex inputs ${onCalcByPlaces ? 'm-b-20' : ''}`}>
        <FormField error={errors['cargoVolume']}>
            <label>Объем, м³*<Info name={'Объем, м³'}
                                   text={'Формула для расчета объёма (м) из габаритов (см): Объём (м2)= Длина (см) × Ширина (см) × Высота (см) / 1 000 000'}/></label>
            <NumberInput
                disabled={isOff}
                id="inputVolume"
                value={form.cargoVolume}
                decimals="5"
                min="0"
                onChange={value => changeParam("cargoVolume", value)}
            />
        </FormField>
        <FormField error={errors['cargoWeight']}>
            <label>Вес, кг*<Info name={'Вес, кг'}
                                 text={'Вес одного места должен быть не больше 30 кг ( 50кг для DHL)'}/></label>
            <NumberInput
                disabled={isOff}
                id="inputWeight"
                value={form.cargoWeight}
                decimals="5"
                min="0"
                onChange={value => changeParam("cargoWeight", value)}
            />
        </FormField>
        <FormField error={errors['cargoPackages']}>
            <label>Кол-во мест*</label>
            <NumberInput
                disabled={isOff}
                id="inputCount"
                value={form.cargoPackages}
                decimals="0"
                min="0"
                onChange={value => changeParam("cargoPackages", value)}
            />
        </FormField>
        {onCalcByPlaces && <FormField className='params-step__toggle'>
            <Checkbox
                toggle
                checked={isOff}
                label='Расчет по местам'
                onChange={(e, {checked}) => onCalcByPlaces(checked)}
            />
        </FormField>}
    </div>
}

export default TotalVolumeAndWeight;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/totalVolumeAndWeight.jsx